// extracted by mini-css-extract-plugin
module.exports = {"carDetailMap":"qvV3H","topBorderCorner":"_28kXF"};